import { render } from "./AppFooter.vue?vue&type=template&id=0d6064e3"
const script = {}

const cssModules = script.__cssModules = {}
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=0d6064e3&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script